export const ADMIN = 'ADMIN';